var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"d-flex justify-center align-center fallback-image"},'div',_vm.$attrs,false),[_c('FontAwesomeIcon',{staticClass:"fallback-image__icon",attrs:{"icon":['far', 'image-slash']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }